import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../config"; // ✅ Import BASE_URL
import { jwtDecode } from "jwt-decode"; // Correctly import the named export
import { Modal, Button } from "react-bootstrap"; // Import Bootstrap Modal
import { ToastContainer, toast } from "react-toastify"; // Import Toastify
import "react-toastify/dist/ReactToastify.css";

const AdminReoccurring = () => {
  const [tasks, setTasks] = useState([]);
  const [user, setUser] = useState(null); // State to store user details
  const [activeUsers, setActiveUsers] = useState([]); // State to store active users
  const [showEditModal, setShowEditModal] = useState(false); // State to control modal visibility
  const [editTask, setEditTask] = useState(null); // State to store the task being edited
  const [selectedDays, setSelectedDays] = useState([]); // State to store selected days
  const [daysOfWeekToSend, setDaysOfWeekToSend] = useState([]); // State for new user-selected days_of_week
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserFromToken = () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token); // Decode the token
          setUser(decoded); // Set user details from the token
          console.log("Decoded User:", decoded); // Log user details to the console
        } catch (err) {
          console.error("Error decoding token:", err);
        }
      }
    };

    const fetchTasks = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await axios.get(`${BASE_URL}api/tasks/all`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        // Filter tasks where repeat_type is not null
        const recurringTasks = res.data.filter(task => task.repeat_type !== null);
        setTasks(recurringTasks);
        // setTasks(res.data);
      } catch (err) {
        console.error("Error fetching recurring tasks:", err);
      }
    };

    const fetchActiveUsers = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await fetch(`${BASE_URL}api/user/active-users`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch active users");
        }

        const users = await response.json();
        const userDetailsArray = users.map((user) => ({
          id: user.id, // Extract user ID
          username: user.username, // Extract username
        }));

        setActiveUsers(userDetailsArray); // Set the active users in state
        console.log("Active Users:", userDetailsArray); // Log the active users
      } catch (error) {
        console.error("Error fetching active users:", error);
      }
    };

    fetchUserFromToken(); // Fetch user details from token
    fetchTasks();
    fetchActiveUsers(); // Fetch active users
  }, []);

  const handleNavigation = (e, path) => {
    e.preventDefault();
    navigate(path);
  };

  const formatDays = (days) => {
    try {
      const firstParse = JSON.parse(days);
      const parsed = JSON.parse(firstParse);
      return Array.isArray(parsed) ? parsed.join(", ") : "";
    } catch (e) {
      return "";
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateStr).toLocaleDateString(undefined, options);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.delete(`${BASE_URL}api/tasks/delete/${id}`);
        toast.success("Task has been deleted."); // Show toast notification
        setTasks((prev) => prev.filter((task) => task.id !== id));
      } catch (err) {
        console.error("Delete error:", err);
        toast.error("Failed to delete the task."); // Show error toast
      }
    }
  };

  const handleEditClick = (task) => {
    setEditTask({
      ...task,
    });
    setDaysOfWeekToSend([]); // Reset days_of_week state for new user input
    setShowEditModal(true);
  };

  const handleDayChange = (day) => {
    setDaysOfWeekToSend((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleSaveChanges = async () => {
    try {
      const token = localStorage.getItem("token");
      const updatedTask = {
        ...editTask,
        days_of_week: editTask.repeat_type === "weekly" && daysOfWeekToSend.length
          ? JSON.stringify(JSON.stringify(daysOfWeekToSend)) // Double JSON.stringify to escape quotes
          : null,
        end_date: editTask.end_type === "on_date" ? editTask.end_date : null,
        max_occurrences: editTask.end_type === "after_occurrences" ? editTask.max_occurrences : null,
        repeat_interval: editTask.repeat_type === "custom" ? editTask.repeat_interval : null,
      };

      const payload = {
        ...updatedTask,
        project: "Recurring Tasks", // Add project field
        list: "TODO", // Add list field
        color: "#0d6efd", // Add color field
        textClass: "text-primary", // Add textClass field
      };

      console.log("Payload before submit:", payload); // Log the payload

      const response = await axios.put(`${BASE_URL}api/tasks/update/${editTask.id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        toast.success("Task updated successfully!");
        setTasks((prev) =>
          prev.map((task) => (task.id === editTask.id ? { ...task, ...updatedTask } : task))
        );
        setShowEditModal(false);
      }
    } catch (err) {
      console.error("Error updating task:", err);
      toast.error("Failed to update the task.");
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">Recurring Tasks</h2>
        <button
          className="btn btn-success"
          onClick={(e) => handleNavigation(e, "/reoccurring-tasks")}
        >
          Create Reoccurring Task
        </button>
      </div>

      {tasks.length === 0 && <p>No recurring tasks found.</p>}
      <div className="row">
        {tasks.map((task) => (
          <div key={task.id} className="col-md-6 col-lg-4 mb-4">
            <div className="card shadow-sm h-100">
              <div className="card-body d-flex flex-column">
                {task.title && (
                  <p>
                    <strong>Title:</strong> {task.title}
                  </p>
                )}
                {task.assignee && (
                  <p>
                    <strong>Assignee:</strong>{" "}
                    {activeUsers.find((user) => user.id === parseInt(task.assignee))?.username || "Unknown"}
                  </p>
                )}
                {task.date && (
                  <p>
                    <strong>Date:</strong> {formatDate(task.date)}
                  </p>
                )}
                {task.details && (
                  <p>
                    <strong>Details:</strong> {task.details}
                  </p>
                )}
                {task.repeat_type && (
                  <p>
                    <strong>Repeat:</strong>{" "}
                    {task.repeat_type === "weekly"
                      ? `Weekly on ${formatDays(task.days_of_week)}`
                      : task.repeat_type}
                  </p>
                )}
                {task.end_type && (
                  <p>
                    <strong>End Type:</strong> {task.end_type}
                    {task.end_type === "on_date" && task.end_date && (
                      <> on {formatDate(task.end_date)}</>
                    )}
                    {task.end_type === "after_occurrences" &&
                      task.max_occurrences && (
                        <> after {task.max_occurrences} times</>
                      )}
                  </p>
                )}
                <div className="mt-auto d-flex justify-content-between">
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleEditClick(task)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDelete(task.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Edit Task Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editTask && (
            <form>
              <div className="mb-3">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={editTask.title}
                  onChange={(e) => setEditTask({ ...editTask, title: e.target.value })}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Details</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={editTask.details}
                  onChange={(e) => setEditTask({ ...editTask, details: e.target.value })}
                ></textarea>
              </div>
              <div className="mb-3 d-flex align-items-center gap-3">
                <div style={{ flex: 1 }}>
                  <label className="form-label">Assignee</label>
                  <select
                    className="form-select"
                    value={editTask.assignee}
                    onChange={(e) => setEditTask({ ...editTask, assignee: e.target.value })}
                  >
                    <option value="" disabled>
                      Select assignee
                    </option>
                    {activeUsers.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.username}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ flex: 1 }}>
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={editTask.date}
                    onChange={(e) => setEditTask({ ...editTask, date: e.target.value })}
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Repeat</label>
                <select
                  className="form-select"
                  value={editTask.repeat_type || "daily"}
                  onChange={(e) => setEditTask({ ...editTask, repeat_type: e.target.value })}
                >
                  <option value="daily">Daily</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                  <option value="custom">Custom</option>
                </select>
              </div>
              {editTask.repeat_type === "weekly" && (
                <div className="mb-3">
                  <label className="form-label fw-semibold">Repeat On</label>
                  <div className="d-flex flex-wrap gap-2">
                    {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                      <div key={day} className="form-check me-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          value={day}
                          onChange={() => handleDayChange(day)}
                          checked={daysOfWeekToSend.includes(day)} // Use new state for checkbox handling
                        />
                        <label className="form-check-label">{day}</label>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">End Type</label>
                <select
                  className="form-select"
                  value={editTask.end_type || "never"}
                  onChange={(e) => {
                    const newEndType = e.target.value;
                    setEditTask({
                      ...editTask,
                      end_type: newEndType,
                      end_date: newEndType === "never" ? null : editTask.end_date, // Set end_date to null if "never" is selected
                    });
                  }}
                >
                  <option value="never">Never</option>
                  <option value="on_date">On a Specific Date</option>
                  <option value="after_occurrences">After X Occurrences</option>
                </select>
              </div>
              {editTask.end_type === "on_date" && (
                <div className="mb-3">
                  <label className="form-label">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={editTask.end_date || ""}
                    onChange={(e) => setEditTask({ ...editTask, end_date: e.target.value })}
                  />
                </div>
              )}
            </form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveChanges}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer /> {/* Add ToastContainer for notifications */}
    </div>
  );
};

export default AdminReoccurring;
